<p-table #dataTable [value]="incidents" dataKey="workItemId" size="small"
[paginator]="true" [rows]="10" [showCurrentPageReport]="true" 
currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[10,25,50]"
sortMode="multiple"  [globalFilterFields]="['workItemId','summary','location.name','assigneeFullName','currentStepName', 'priority.name', 'tagSearchString', 'personalInjuryText', 'financialImpactText']"
[stateKey]="stateKey" [loading]="loading" class="responsive-table">
<ng-template pTemplate="caption">
  <div class="flex justify-between items-center">
    <button pButton label="" class="p-button-outlined" icon="pi pi-filter-slash" (click)="clear(dataTable)"></button>
      <!-- <button class="btn btn-outline-primary" (click)="clear(dataTable)">Clear</button> -->
      <div class="flex gap-2 items-center" >
          <i class="pi pi-search"></i>
          <input pInputText type="text" [(ngModel)]="currentFilter" (input)="dataTable.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Search keyword" />
      </div>
  </div>
</ng-template>  
<ng-template pTemplate="header">
    <tr>
        <th></th>
        <th *ngIf="isColumnVisible('id')" pSortableColumn="workItemId">Id<p-sortIcon field="workItemId"></p-sortIcon></th>
        <th *ngIf="isColumnVisible('date')" pSortableColumn="startDate">
          Incident Date
          <p-sortIcon field="startDate"></p-sortIcon> 
          <p-columnFilter type="date" field="startDate" display="menu"></p-columnFilter>
        </th>
        <th *ngIf="isColumnVisible('summary')" pSortableColumn="summary">
          Summary
          <p-sortIcon field="summary"></p-sortIcon>
          <p-columnFilter type="text" field="summary" display="menu"></p-columnFilter>
        </th>
        <th *ngIf="isColumnVisible('location')" pSortableColumn="location.name">
          Location
          <p-sortIcon field="location.name"></p-sortIcon>
          <p-columnFilter type="text" field="location.name" display="menu"></p-columnFilter>
        </th>
        <th *ngIf="isColumnVisible('status')" pSortableColumn="currentStepName" >
          Status
          <p-sortIcon field="currentStepName"></p-sortIcon>
          <p-columnFilter type="text" field="currentStepName" display="menu"></p-columnFilter>
        </th>
        <th *ngIf="isColumnVisible('priority')"pSortableColumn="priority.order">
          Priority
          <p-sortIcon field="priority.order"></p-sortIcon>
          <p-columnFilter type="text" field="priority.name" display="menu"></p-columnFilter>
        </th>
        <th *ngIf="isColumnVisible('assignee')" pSortableColumn="assigneeFullName">
          Assigned To
          <p-sortIcon field="assigneeFullName"></p-sortIcon>
          <p-columnFilter type="text" field="assigneeFullName" display="menu"></p-columnFilter>
        </th>
        <th *ngIf="isColumnVisible('submitted')" pSortableColumn="dateCreated">
          Submitted
          <p-sortIcon field="dateCreated"></p-sortIcon>
          <p-columnFilter type="date" field="dateCreated" display="menu"></p-columnFilter>
        </th>
        <th *ngIf="isColumnVisible('tags')" >
          Tags
          <p-columnFilter type="text" field="tagSearchString" display="menu"></p-columnFilter>
        </th>
        <th *ngIf="isColumnVisible('personalInjury')" pSortableColumn="severityImpact.personalInjuryLevel">
          Personal Injury
          <p-sortIcon field="personalInjuryText"></p-sortIcon>
          <p-columnFilter type="text" field="personalInjuryText" display="menu"></p-columnFilter>
        </th>
        <th *ngIf="isColumnVisible('financialImpact')" pSortableColumn="severityImpact.financialImpactLevel">
          Financial Impact
          <p-sortIcon field="financialImpactText"></p-sortIcon>
          <p-columnFilter type="text" field="financialImpactText" display="menu"></p-columnFilter>
        </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-incident>
    <tr>
        <td>
            <p-menu #rowMenu [popup]="true" [model]="getMenuActions(incident)" appendTo="body"></p-menu>
            <button type="button" pButton icon="pi pi-angle-down" label="" class="p-button-sm" (click)="rowMenu.toggle($event)"></button>
  
        </td>
        <td (click)="onRowClick(incident)" *ngIf="isColumnVisible('id')">{{incident.workItemId}}</td>
        <td (click)="onRowClick(incident)" *ngIf="isColumnVisible('date')">{{incident.startDate | date}}</td>
        <td (click)="onRowClick(incident)" *ngIf="isColumnVisible('summary')">{{incident.summary}}</td>
        <td (click)="onRowClick(incident)" *ngIf="isColumnVisible('location')">{{incident?.location?.name}}</td>
        <td *ngIf="isColumnVisible('status')" >
            <app-transition-button *ngIf="useTransitionButton ; else statusOnly"  class="d-inline-block" size="small" [incident]="incident"(transitionComplete)="onIncidentUpdate($event)"></app-transition-button>
            <ng-template #statusOnly>
              <span (click)="onRowClick(incident)" >{{incident.currentStepName}}</span>
            </ng-template>
        </td>
        <td *ngIf="isColumnVisible('priority')" >
          <app-priority-button size="small" [incident]="incident" (updateComplete)="onIncidentUpdate($event)"></app-priority-button>
        </td>
        <td (click)="onRowClick(incident)" *ngIf="isColumnVisible('assignee')">{{incident?.assigneeFullName}}</td>
        <td (click)="onRowClick(incident)" *ngIf="isColumnVisible('submitted')">{{incident.dateCreated | date:'medium'}}</td>
        <td (click)="onRowClick(incident)" *ngIf="isColumnVisible('tags')"><app-tag-display [incident]="incident" (tagChanged)="tagChanged()"></app-tag-display></td>
        <td (click)="onRowClick(incident)" *ngIf="isColumnVisible('personalInjury')">{{incident.personalInjuryText}}</td>
        <td (click)="onRowClick(incident)" *ngIf="isColumnVisible('financialImpact')">{{incident.financialImpactText}}</td>
    </tr>
  </ng-template>
</p-table>
